import { Icon, Shadow, Text, Avatar, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

import { columnWidthsTablet } from '../../constants';

import { TradingListItemTypes } from '.';

export const TradingListItemTablet: React.FC<TradingListItemTypes.Content> = ({
  item,
  handleNavigate,
}) => {
  return (
    <Shadow
      height={85}
      borderRadius={Spacing['inset.nano']}
      paddingX={Spacing['inset.xs']}
      paddingY={Spacing['inset.xs']}
      margin={Spacing['inset.xs']}
      level={2}
      justifyContent={'center'}>
      <Pressable
        onPress={() =>
          handleNavigate({
            currentSinacorAccount: item.contaSinacorSemDigito,
            currentAccountPNP: item.contaSuperPNPSemDigito,
            currentIdAccount: item.idConta,
            currentAccountBP: item.contaBPComDigito,
          })
        }>
        <HStack>
          <HStack justifyContent={'space-between'} flex={1}>
            <VStack width={columnWidthsTablet.name}>
              <Text
                paddingBottom={1}
                fontSize={Typography['fontsize.xs']}
                fontWeight={Typography['fontweight.semibold']}>
                Nome
              </Text>
              <HStack space={Spacing['inline.nano']} alignItems="center">
                <Avatar
                  testId="client-avatar"
                  textColor="neutral.white"
                  bgColor={'brand.primary.light'}
                  initials={item.initials}
                />
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.regular']}
                  fontSize={Typography['fontsize.md']}
                  flex={1}
                  textAlign="start">
                  {item.nomeCliente}
                </Text>
              </HStack>
            </VStack>

            <VStack width={columnWidthsTablet.email}>
              <Text
                paddingBottom={1}
                fontSize={Typography['fontsize.xs']}
                fontWeight={Typography['fontweight.semibold']}>
                E-mail
              </Text>
              <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                fontWeight={Typography['fontweight.regular']}
                fontSize={Typography['fontsize.md']}
                // flex={1}
                textAlign="start">
                {item.email}
              </Text>
            </VStack>

            <VStack width={columnWidthsTablet.personType}>
              <Text
                paddingBottom={1}
                fontSize={Typography['fontsize.xs']}
                fontWeight={Typography['fontweight.semibold']}>
                Pessoa
              </Text>
              <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                fontWeight={Typography['fontweight.regular']}
                fontSize={Typography['fontsize.md']}
                flex={1}
                textAlign="start">
                {item.tipoPessoaNormalized}
              </Text>
            </VStack>

            <VStack width={columnWidthsTablet.sinacorAccount}>
              <Text
                paddingBottom={1}
                fontSize={Typography['fontsize.xs']}
                fontWeight={Typography['fontweight.semibold']}
                color="neutral.medium">
                Conta sinacor
              </Text>
              <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                fontWeight={Typography['fontweight.regular']}
                fontSize={Typography['fontsize.md']}
                flex={1}
                color="neutral.medium"
                textAlign="start">
                {item.contaSinacorComDigito}
              </Text>
            </VStack>

            <VStack width={columnWidthsTablet.custodyAccount}>
              <Text
                paddingBottom={1}
                fontSize={Typography['fontsize.xs']}
                fontWeight={Typography['fontweight.semibold']}>
                Conta de custódia
              </Text>
              <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                fontWeight={Typography['fontweight.regular']}
                fontSize={Typography['fontsize.md']}
                flex={1}
                textAlign="start">
                {item.contaSuperPNPComDigito}
              </Text>
            </VStack>

            <VStack width={columnWidthsTablet.accountBP}>
              <Text
                paddingBottom={1}
                fontSize={Typography['fontsize.xs']}
                fontWeight={Typography['fontweight.semibold']}>
                Conta BP
              </Text>
              <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                fontWeight={Typography['fontweight.regular']}
                fontSize={Typography['fontsize.md']}
                flex={1}
                textAlign="start">
                {item.contaBPComDigito}
              </Text>
            </VStack>
          </HStack>

          <HStack alignItems="center">
            <Icon
              name="ChevronRight"
              color={Color['brand.tertiary.principal']}
              testId="action-button"
              size="sm"
            />
          </HStack>
        </HStack>
      </Pressable>
    </Shadow>
  );
};
